<div class="transaction_detail_modal" *ngIf="tranDetail; else shimmerTemplate">
  <div id="screen" #screen>
    <div class="modal-header px-0">
      <div class="profile_img">
        <img *ngIf="image" id="profile" src="{{ image }}" alt="userImg" />
        <div *ngIf="!image" class="trans-name-image">
          {{
            tranDetail.nonExplorePayReceiver || tranDetail.transactionWith
              | slice: 0 : 2
          }}
        </div>
      </div>
      <div class="profile_detail">
        <label>{{ title }}</label>
        <p *ngIf="tranDetail.notes">
          {{ tranDetail.notes ? "Note: " + tranDetail.notes : "" }}&nbsp;
        </p>
        <span>
          {{ tranDetail.transactionType === 1 ? "+" : "-" }}
          {{ tranDetail.currencySymbol
          }}{{ tranDetail.transferAmount | number: "0.2-2" }}
        </span>
      </div>
      <button
        type="button"
        class="btn-close close pull-right"
        aria-label="Close"
        (click)="modalRef.hide()"
      >
        <img src="../../../../../assets/img/modal_cancel.svg" />
      </button>
    </div>
    <div class="modal-body">
      <ul>
        <li>
          <label>Date & Time:</label>
          <span>{{ tranDetail.createdAt | date: "dd-MM-yyyy hh:mm a" }}</span>
        </li>
        <li>
          <label>Payment Method:</label>
          <span>{{
            tranDetail.stripeResponseJSON?.card
              ? "Credit Card****" + tranDetail.stripeResponseJSON?.card?.last4
              : "SmartPay wallet"
          }}</span>
        </li>
        <li>
          <label>Fee:</label>
          <span>{{ tranDetail.fees ? "$" + tranDetail.fees : "Free" }}</span>
        </li>
        <li>
          <label>Transaction ID:</label>
          <span>{{ tranDetail.shortId }}</span>
        </li>
        <li>
          <label>Reward Point:</label>
          <span>{{ tranDetail.redeemedPoints || 0 }}</span>
        </li>
        <li>
          <label>Transaction status:</label>
          <span>{{ tranDetail.status | transactionStatus }}</span>
        </li>
      </ul>

      <div class="map_section"></div>
    </div>
  </div>
  <div class="frm-btn">
    <button
      class="border_btn mr-3"
      (click)="DownloadScreen(title + ' ' + tranDetail.shortId)"
    >
      Download Receipt
    </button>
    <button class="fill_btn" (click)="ShareScreen()" type="button">
      Share
    </button>
  </div>
</div>
<ng-template #shimmerTemplate>
  <ngx-skeleton-loader
    [theme]="{ width: '95%', height: '100px', 'border-radius': '10px' }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    [theme]="{ width: '95%', height: '100px', 'border-radius': '10px' }"
  ></ngx-skeleton-loader>
  <ngx-skeleton-loader
    [theme]="{ width: '95%', height: '100px', 'border-radius': '10px' }"
  ></ngx-skeleton-loader>
</ng-template>
